<template>
  <div class="bubble text-left">
    <p class="text-title">{{ $t('inviteFeedback') }}</p>
    <p class="text-content">{{ $t('inviteDesc') }}}</p>
    <button class="message-btn" @click="goToStore">
      {{ $t('inviteBtn') }}
    </button>
  </div>
</template>

<script>
import kylogger from '@ky/sdk/dist/log/kylogger'
export default {
  name: 'Card',
  mounted() {
    kylogger.collect('SHOW', 'IM_FEEDBACK', {})
  },
  methods: {
    goToStore() {
      kylogger.collect('CLICK', 'IM_FEEDBACK', {})
      const feedbackUrl =
        'kwaiying://krn?bundleId=KyFeedback&componentName=feedback&from=IM'
      window.open(feedbackUrl)
    },
  },
}
</script>

<style lang="less" scoped>
.bubble {
  margin-top: 0.32rem;
  border-radius: 0.4rem;
  overflow: hidden;
  word-break: break-all;
  box-sizing: border-box;
  &.text-left {
    max-width: 80%;
    padding: 0.4rem 0.32rem;
    background-color: #222;
    color: rgba(255, 255, 255, 0.9);
    border-top-left-radius: 0.1rem;
  }
  .message-btn {
    background: linear-gradient(
      135deg,
      #f52c6f 0%,
      #f7365d 49.58%,
      #ff5151 100%
    );
    border-radius: 0.5rem;
    border: 0;
    height: 0.6rem;
    width: 2.08rem;
    font-size: 0.24rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
    margin-top: 0.24rem;
  }
  .text-title {
    font-size: 0.3rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    line-height: 120%;
    text-align: justify;
  }
  .text-content {
    font-size: 0.26rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 150%;
    margin-top: 0.16rem;
    text-align: justify;
  }
}
</style>
